export const LAYOUT_COMPACT_MAX_WIDTH = 767

/** SplitLayout + hide mobile header on login/OTP when both dimensions meet this. */
export const SPLIT_LAYOUT_MIN_WIDTH = 1200
export const SPLIT_LAYOUT_MIN_HEIGHT = 700

export const AUTH_FORM_VARIANT = {
  CARD: 'card',
  FLUID: 'fluid'
}
